// eslint-disable-next-line boundaries/element-types
import { ComponentType } from '@angular/cdk/portal';

import { DialogConfigOptions } from '@core/user-interface-legacy';

export type SkillsIdeateStatus = 'processing' | 'completed' | 'failed';

export interface SkillsIdeateResultProficiency {
  name: string;
  description: string;
  positions: string[];
}

export interface SkillsIdeateResultSkill {
  name: string;
  description: string;
  category: string;
  proficiencies: SkillsIdeateResultProficiency[];
}

export interface SkillsIdeateResultTab {
  name: string;
  skills: SkillsIdeateResultSkill[];
}

export interface SkillsIdeateResultJson {
  skillLabel: string;
  categoryLabel: string;
  descriptionLabel: string;
  expectationsLabel: string;
  tabs: SkillsIdeateResultTab[];
}

export type SkillsIdeate = {
  id: number;
  status: SkillsIdeateStatus;
  resultJson: SkillsIdeateResultJson | null;
  errorMessage: string | null;
  createdAt: string;
  startedAt: string | null;
  updatedAt: string;
};

export type SkillsIdeateStartParams = {
  positionGuids: string[];
  proficiencyTierNames: string[];
  userPrompt?: string | null;
};

export interface SkillsMatrixExportSkill {
  name: string;
  description: string;
  category: string;
  positions: string[];
  proficiencyLevels: string[];
  expectations: string[];
}

export interface SkillsMatrixExportGroup {
  name: string;
  skills: SkillsMatrixExportSkill[];
}

export interface SkillsMatrixExportData {
  title: string;
  groups: SkillsMatrixExportGroup[];
}

export type SkillsIdeateStep = 'intro' | 'generate_options' | 'loading' | 'result' | 'result_error';

export interface SkillsIdeateFlowData {
  id: number;
  resultJson: SkillsIdeateResultJson | null;
  error: string | null;
}

export interface SkillsIdeateStepDefinition {
  step: SkillsIdeateStep;
  canMatch?: (data: Partial<SkillsIdeateFlowData>) => boolean;
}

export interface SkillsIdeateStepI {
  dialogComponent: ComponentType<any>;
  dialogConfig: DialogConfigOptions;
}

export type ProficiencyTierId =
  | 'novice'
  | 'beginner'
  | 'competent'
  | 'proficient'
  | 'advanced'
  | 'expert';

export const PROFICIENCY_TIER_PRESET_FOUR: ProficiencyTierId[] = [
  'beginner',
  'competent',
  'advanced',
  'expert',
];

export const PROFICIENCY_TIER_PRESET_FIVE: ProficiencyTierId[] = [
  'novice',
  'beginner',
  'competent',
  'proficient',
  'expert',
];
